import { ctaCreateId, searchId, segmentDisplayId } from "@/assets/googleTrackIds";
import { FiltersButton } from "@/components/Dataheader/FiltersButton";
import { FiltersDrawer } from "@/components/Dataheader/FiltersDrawer";
import { FC, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import qs from "query-string";
import { DashboardRoutes } from "@/router/constant";
import {
  Button,
  DataHeader,
  Flex,
  Input,
  LegacyForm,
  Segmented,
  Typography,
  usePaypingContext,
} from "@payping/web-components";
import { Add, PhRArchive, PhRPercent } from "@payping/icons";
import { submitQueryParams } from "@payping/utils/query-string";
import { useAppTranslation } from "@/utils";
import { ListBoolQueryParamsType, ListStringQueryParamsType } from "@/pages/Shop/Product/types";

interface Props {
  retry: () => void;
  loading: boolean;
}

const CouponFilter: FC<Props> = (props) => {
  const { retry } = props;
  const location = useLocation();
  const parsedSearch = qs.parse(location.search);
  // Because there are different types of filters, we should separate parsing them to avoid conflict between types (like converting "241e43" string to scientific number 2.41e45)
  const { isArchived }: ListBoolQueryParamsType = qs.parse(location.search, { parseBooleans: true });
  const { searchText }: ListStringQueryParamsType = qs.parse(location.search);
  const { t } = useAppTranslation();
  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [form] = LegacyForm.useForm();
  const { breakpoints } = usePaypingContext();
  const { xs } = breakpoints;

  useEffect(() => {
    form.setFieldsValue({
      isArchived: Boolean(isArchived),
    });
  }, [form, isArchived]);

  return (
    <LegacyForm
      onFinish={(values) => {
        const newValues = {
          searchText: values.searchText,
        };
        submitQueryParams({
          navigate,
          newValues,
          parsedSearch,
          pathname: location.pathname,
          retry,
        });
        setOpenDrawer(false);
      }}
      form={form}
    >
      <DataHeader
        title={
          <Typography.Title className={"tw:m-0!"} level={4}>
            {t("pageTitles.couponList")}
          </Typography.Title>
        }
        primaryAction={
          <Button
            type={"primary"}
            onClick={(): void => {
              navigate(
                {
                  pathname: DashboardRoutes.myShop.coupon.create.url,
                },
                { state: { locationSearch: location.search } },
              );
            }}
            icon={<Add width={14} height={14} />}
            data-google-track={ctaCreateId}
          >
            {t("coupon.add")}
          </Button>
        }
        filters={{
          segmentsButton: (
            <Segmented
              key={1}
              options={[
                {
                  value: 0,
                  icon: <PhRPercent width={16} />,
                  label: t("common.discounts"),
                },
                {
                  value: 1,
                  icon: <PhRArchive width={16} />,
                  label: t("archived"),
                },
              ]}
              onChange={(value) => {
                const newValues = {
                  isArchived: Boolean(value),
                };
                return submitQueryParams({
                  navigate,
                  newValues,
                  parsedSearch,
                  pathname: location.pathname,
                  retry,
                });
              }}
              data-google-track={segmentDisplayId}
            />
          ),
          searchbarInput: (
            <LegacyForm.Item key={2} name={"searchText"} noStyle>
              <Input.Search
                className={"tw:w-full"}
                allowClear
                placeholder={t("coupon.placeholder")}
                onSearch={() => form.submit()}
                data-google-track={searchId}
              />
            </LegacyForm.Item>
          ),
          filtersButton: xs ? (
            <>
              <FiltersButton onClick={() => setOpenDrawer(true)} params={{ searchText }} />

              <FiltersDrawer
                title={t("filter")}
                onClose={() => setOpenDrawer(false)}
                open={openDrawer}
                onClickApplyFilters={() => form.submit()}
                onClickResetFilters={() => {
                  navigate({ pathname: location.pathname });
                  form.resetFields();
                  setOpenDrawer(false);
                }}
              >
                <Flex vertical gap={8}>
                  <>
                    {/* < searchText > */}
                    <LegacyForm.Item name={"searchText"} label={t("search.search")} layout={"vertical"}>
                      <Input
                        className={"w-100"}
                        allowClear
                        placeholder={t("coupon.placeholder")}
                        data-google-track={searchId}
                      />
                    </LegacyForm.Item>
                  </>
                </Flex>
              </FiltersDrawer>
            </>
          ) : null,
        }}
      />
    </LegacyForm>
  );
};

export default CouponFilter;
